import { useRouter, useI18n } from '@popety_io/popety-io-lib'
import { useEffect, useMemo, useState } from 'react'
import { useSelector } from 'react-redux'

import { poisSelector, displayPoisSelector } from '../../../../redux'
import TransportType from '../TransportType'
import {
  createLivabilityIcon,
  createLivabilityIconPopup,
} from './Livability.util'

const LivabilityMapContent = ({
  map,
  mapboxgl,
  loaded,
}: Record<string, any>) => {
  const { t } = useI18n()
  const display = useSelector(displayPoisSelector)
  const { query } = useRouter()
  const poisCategories: string = query.poisCategories || ''

  const pois: any[] = useSelector(poisSelector)

  const isLivabilityTab = useMemo(
    () => query.subTab === 'livability',
    [query.subTab],
  )

  const poisCategoriesArray = useMemo(
    () =>
      poisCategories
        .replaceAll(', ', '%%')
        .split(',')
        .map((i) => i.replaceAll('%%', ', ')),
    [poisCategories],
  )

  const filteredPois = useMemo(
    () =>
      poisCategories.length
        ? pois?.filter((poi) => !poisCategoriesArray?.includes(poi.subcategory))
        : pois,
    [pois, poisCategories, poisCategoriesArray],
  )

  const [mapMarkers, setMapMarkers] = useState<any[]>([])

  useEffect(() => {
    // removing markers
    if (!isLivabilityTab) {
      mapMarkers.forEach((marker) => marker.remove())
      setMapMarkers([])
    }
  }, [isLivabilityTab, mapMarkers.length])

  useEffect(() => {
    if (!map || !loaded || !isLivabilityTab || !pois.length) return

    // removing
    if (mapMarkers.length > 0) {
      mapMarkers.forEach((marker) => marker.remove())
      setMapMarkers([])
    }

    // add markers to map
    const markers = filteredPois
      .map((feature) => {
        if (!display) return null

        let center: any

        if (feature.geo_center_lon && feature.geo_center_lat) {
          center = [feature.geo_center_lon, feature.geo_center_lat]
        } else if (feature.geo_polygon_lat && feature.geo_polygon_lon) {
          center = [feature.geo_polygon_lon, feature.geo_polygon_lat]
        }

        if (!center) return null

        const el = createLivabilityIcon(feature.categoryKey)
        const iconPopup = createLivabilityIconPopup(mapboxgl, feature, t)

        return new mapboxgl.Marker(el)
          .setLngLat(center)
          .setPopup(iconPopup)
          .addTo(map)
      })
      .filter(Boolean)

    setMapMarkers(markers)

    return () => {
      markers.forEach((marker) => marker.remove())
      setMapMarkers([])
    }
  }, [isLivabilityTab, poisCategories, loaded, pois, display])

  if (!isLivabilityTab) return null

  return (
    <>
      <TransportType />
      <div>{t('lang.map_content_goes_here')}</div>
    </>
  )
}

export default LivabilityMapContent
